var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM5.6129 4.2097C5.22061 3.90468 4.65338 3.93241 4.29289 4.29289L4.2097 4.3871C3.90468 4.77939 3.93241 5.34662 4.29289 5.70711L6.585 8L4.29289 10.2929L4.2097 10.3871C3.90468 10.7794 3.93241 11.3466 4.29289 11.7071L4.3871 11.7903C4.77939 12.0953 5.34662 12.0676 5.70711 11.7071L8 9.415L10.2929 11.7071L10.3871 11.7903C10.7794 12.0953 11.3466 12.0676 11.7071 11.7071L11.7903 11.6129C12.0953 11.2206 12.0676 10.6534 11.7071 10.2929L9.415 8L11.7071 5.70711L11.7903 5.6129C12.0953 5.22061 12.0676 4.65338 11.7071 4.29289L11.6129 4.2097C11.2206 3.90468 10.6534 3.93241 10.2929 4.29289L8 6.585L5.70711 4.29289L5.6129 4.2097Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.75ecc2c003f06d9440300c42bc70e069.svg";
export { ForwardRef as ReactComponent };